<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>طباعة كشوف التحصيل</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم طباعة كشوف التحصيل والصيانة بالنسبة لكل فنى
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="row">
                              <div class='col-lg-2 col-md-2 col-sm-2'>
                                    <span>الفرع</span>
                                    <select  @change='Getcollectors(branche)' class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-3'>
                                <span>المحصل:</span>
                                <select class="form-control" v-model="collector">
                                  <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                                    {{ collector.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-4 col-md-4 col-sm-4' style="padding:0px">
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <span>&nbsp;</span>
                                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                                    <b> عرض </b>
                                  </button>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-3'>
                                  <span>&nbsp;</span>
                                    <button v-show="$per.value.printReceipt" v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' >
                                      <b> طباعة </b>
                                    </button>
                                </div>
                              </div>
</div>
                              <br>
                              <div id="contentToPrint">
                              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='text-align: center'>م</th>
                                      <th style='text-align: center'>السجل</th>
                                      <th style='text-align: center'>الاسم</th>
                                      <th style='text-align: center'>اسم الشهرة</th>
                                      <th style='text-align: center'>المحمول</th>
                                      <th style='text-align: center'>المنطقة</th>
                                      <th style='text-align: center'>العنوان</th>
                                      <th style='text-align: center'>ملاحظات</th>
                                      <th style='text-align: center'>الصنف</th>
                                      <th style='text-align: center'>النوع</th>
                                      <th style='text-align: center'>الكود</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.customers_rec_id}} {{record.rec_id_letter}}</td>
                                         <td align='center'>{{record.name}}</td>
                                         <td align='center'>{{record.nickname}}</td>
                                        <td align='center'>{{record.mobile}} {{record.mobile2}}</td>
                                        <td align='center'>{{record.region_name}}</td>
                                        <td align='center'>{{record.address}}</td>
                                        <td align='center'>{{record.notes}}</td>
                                        <td align='center'>{{record.item}}</td>
                                        <td align='center'>{{record.rec_typeName}}</td>
                                        <td align='center'>{{record.id}}</td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /. Contracts modal End -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'PrintCollectingstatement',
  data () {
    return {
      validationErrors: '',
      records: {},
      errorShow: false,
      isLoadingData: false,
      collectors: {},
      collector: null,
      collectorTo: null,
      branches: {},
      branche: 0
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = this.branches[0].id
    this.Getcollectors(this.branche)
  },
  methods: {
    Getcollectors (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
      }
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPrintCollectingSheet', {
        token: localStorage.getItem('token'),
        collector: this.collector
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteItineraries', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    },
    // ==================================================
    deleteReceiptsheet (rec) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'deleteReceiptsheet', {
        token: localStorage.getItem('token'),
        id: rec.id,
        rec_type: rec.rec_type,
        rec_id: rec.rec_id,
        contract_id: rec.contract_id
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(rec.rec_id)
          this.records.splice(i, 1)
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ==================================================
    deleteAllReceipt (rec) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'deleteAllReceipt', {
        token: localStorage.getItem('token'),
        id: rec.id,
        rec_type: rec.rec_type,
        rec_id: rec.rec_id,
        contract_id: rec.contract_id
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(rec.rec_id)
          this.records.splice(i, 1)
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/PrintCollectingstatement.vue